module.exports = __webpack_public_path__ + "img/btn_stroll.b1b68db2.png";